/**
 * Thin gtag wrapper for funnel / product events. No-ops when gtag is unavailable.
 */

export const ANALYTICS_EVENTS = {
  FUNNEL_LANDING_CTA: "funnel_landing_cta",
  FUNNEL_PREFS_COMPLETE: "funnel_prefs_complete",
  FUNNEL_JOB_TEASER_VIEW: "funnel_job_teaser_view",
  FUNNEL_PAYWALL_OPEN: "funnel_paywall_open",
  FUNNEL_CHECKOUT_START: "funnel_checkout_start",
  FUNNEL_CHECKOUT_SUCCESS: "funnel_checkout_success",
  FUNNEL_CHECKOUT_CANCEL: "funnel_checkout_cancel",
  FUNNEL_UNLOCK_COMPLETE: "funnel_unlock_complete",
  TOOL_RESUME_SAVE: "tool_resume_save",
  TOOL_GENERATE_START: "tool_generate_start",
  TRACK_STATUS_CHANGE: "track_status_change",
  PRICING_HOW_IT_WORKS_VIEW: "pricing_how_it_works_view",
  PAYWALL_UNLOCK_LIST_IMPRESSION: "paywall_unlock_list_impression",
};

/**
 * @param {string} eventName
 * @param {Record<string, string | number | boolean | undefined | null>} [params]
 */
export function trackEvent(eventName, params = {}) {
  if (typeof window === "undefined") return;
  const cleaned = {};
  if (params && typeof params === "object") {
    for (const [key, value] of Object.entries(params)) {
      if (value === undefined || value === null || value === "") continue;
      cleaned[key] = value;
    }
  }
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, cleaned);
    }
  } catch {
    // analytics must never break product flows
  }
}
